<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="i in 6" :key="i" cols="6" sm="4" md="6" xl="4">
        <div
          :class="[paddingX, paddingY]"
          class="fact-card primary d-flex flex-column justify-space-between white--text"
        >
          <div v-if="i" :class="leadSize">
            {{ $t(`content.sections.intro.facts.${i}.lead`) }}
          </div>
          <div v-if="i">{{ $t(`content.sections.intro.facts.${i}.body`) }}</div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    leadSize() {
      return this.$vuetify.breakpoint.smAndDown ? "display-1" : "display-2";
    },
    paddingX() {
      return this.$vuetify.breakpoint.smAndDown ? "py-8" : "pa-8";
    },
    paddingY() {
      return this.$vuetify.breakpoint.smAndDown ? "px-4" : "";
    }
  }
};
</script>

<style scoped>
.fact-card {
  min-height: 240px;
  /* box-shadow: 2px 1px 0px #fff, 4px 3px 0px #000; */
}
</style>
